import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import alertify from "alertifyjs";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

@Component({
  selector: 'app-invoice-validation-modal',
  templateUrl: './invoice-validation-modal.component.html',
  styleUrls: ['./invoice-validation-modal.component.css']
})
export class InvoiceValidationModalComponent implements OnInit {


  constructor(
    private apiService: ApiServiceService,
    private fb: FormBuilder,
    private bsModalService: BsModalService,
    private router: Router,

  ) {

  }

  @Input() callback: (data: any) => void;




  invoiceValidationForm: FormGroup;


  closeModal() {
    this.bsModalService.hide();
    this.router.navigate(['/'])
  }


  ngOnInit(): void {
    this.invoiceValidationForm = this.fb.group({
      invoiceNumber: ["", [Validators.required]],
    });
    
  }



  get invoiceNumberControl() {
    return this.invoiceValidationForm.get("invoiceNumber");
  }

  userDetailsValidated: boolean;
  isVerifyingAsin: boolean;

  

  
  processInvoiceDetials() {
    this.isVerifyingAsin = true;
    const url = "/assessments/pay/invoice?invoiceNumber=" + this.invoiceValidationForm.value.invoiceNumber;
    this.apiService.get(url, {}).subscribe(
      (res) => {
      



        if (res.data && res.success) {
          this.isVerifyingAsin = false;
          this.callback(res)
        }else{
            this.isVerifyingAsin = false;

            const invoiceAlreadyPaid = res.message == 'Invoice already paid';
            if(invoiceAlreadyPaid) {
              this.invoiceValidationForm.get('invoiceNumber').setErrors({invoiceAlreadyPaid: true})
            }
            else {
              this.invoiceValidationForm.get('invoiceNumber').setErrors({invalid: true})

            }
            alertify.set("notifier", "position", "top-center");

            alertify.error("Error validating invoice: " + res.message);
        }
      },
      (error) => {
        this.isVerifyingAsin = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("An error occured, please try again later");
      }
    );
  }
}
